import api from 'api';

export const loadSubscription = api('GET /api/profile/subscriptions/:id');

export const createSubscription = api('POST /api/profile/subscriptions');

export const updateSubscription = api('PUT /api/profile/subscriptions');

export const deleteSubscription = api('DELETE /api/profile/subscriptions/:id');

export const loadSubscriptions = api('GET /api/profile/subscriptions/grid');

export const loadUsers = api('GET /api/profile/subscriptions/users');
